import { render } from "./StandardMssLiteraryFormT.vue?vue&type=template&id=6d6e06a7"
import script from "./StandardMssLiteraryFormT.vue?vue&type=script&lang=js"
export * from "./StandardMssLiteraryFormT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__